// src/hooks/usePlanesUsuario.js
import { useEffect, useState, useMemo } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export default function usePlanesUsuario(uid) {
  const [planes, setPlanes] = useState({});
  const [loadingPlanes, setLoadingPlanes] = useState(true);

  useEffect(() => {
    if (!uid) {
      setPlanes({});
      return;
    }

    const q = query(
      collection(db, "planes_usuarios"),
      where("uid", "==", uid)
    );

    const unsub = onSnapshot(q, (snap) => {
      const out = {};

      snap.forEach((doc) => {
        const data = doc.data();
        const planId = data.planId || doc.id;

        const total = data.sesiones_totales ?? 1;
        const usadas = data.sesiones_usadas ?? 0;
        const reservadas = data.sesiones_reservadas ?? 0;
        const disponibles = Math.max(total - (usadas + reservadas), 0);

        const precioSesion = data.precio_por_sesion
          ?? (data.precio_total ? Math.round(data.precio_total / total) : 0);

        const pago_realizado = data.pago_total_realizado ?? 0;
        const montoRestante = data.monto_restante
          ?? Math.max((data.precio_total ?? 0) - pago_realizado, 0);

        // 🎯 NUEVO: detectar estado del plan
        const pagado100 = montoRestante === 0;
        const esUltima = disponibles === 1;
        const puedeReservar = disponibles > 0;

        // 🎯 NUEVO: determinar tipo de pago sugerido
        let pago_tipo = "incluida";
        if (!pagado100) {
          pago_tipo = esUltima ? "pago_total_restante" : "pago_proxima";
        }

        out[planId] = {
          ...data,
          planId,
          sesiones_totales: total,
          sesiones_usadas: usadas,
          sesiones_reservadas: reservadas,
          sesiones_disponibles: disponibles,

          precio_por_sesion: precioSesion,
          monto_restante: montoRestante,

          // NUEVOS CAMPOS DERIVADOS
          pagado100,
          esUltima,
          puedeReservar,
          pago_tipo,
        };
      });

      setPlanes(out);
      setLoadingPlanes(false);
    });

    return () => unsub();
  }, [uid]);

  // 🎯 NUEVO: devolver solo el plan ACTIVO (si hay uno)
  const planActivo = useMemo(() => {
    const values = Object.values(planes);
    if (values.length === 0) return null;

    // regla simple: el que tiene sesiones_disponibles > 0
    return values.find(p => p.puedeReservar) || null;
  }, [planes]);

  return { planes, planActivo, loadingPlanes };
}
